import React from "react";
import { Database } from "lucide-react";

const EmptyState = ({ message, title = "No Data Found" }) => {
  return (
    <div className="empty-state">
      <Database className="icon" />
      <h3>{title}</h3>
      <p>{message}</p>
    </div>
  );
};

export default EmptyState;
